export function formatNumberWithSpaces(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function roundNumber(number) {
  return Math.ceil(number * 100) / 100;
}
